import { render, staticRenderFns } from "./DeveloperDetail.vue?vue&type=template&id=c8d8aaf0&scoped=true&"
import script from "./DeveloperDetail.vue?vue&type=script&lang=js&"
export * from "./DeveloperDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperDetail.vue?vue&type=style&index=0&id=c8d8aaf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d8aaf0",
  null
  
)

export default component.exports